import React, { useEffect, useState } from "react";
import { Card, Form, Image, Row, Col, Modal, Button } from "react-bootstrap";
import "./ClothPriceStep1.css";
import { useNavigate, useParams } from "react-router-dom";
import { handleGetPrintType_list } from "./orderModel";
import { getImageUrl } from "../../../../MIS/Global";
import noImage from "../../../../Assets/No_Image_Available.jpg";

const defaultImage = noImage;

const PrintType = ({ selectedCloth, setSelectedCloth, quote }) => {
  const { id, subid } = useParams();
  const navigate = useNavigate();
  const [clothOptions, setClothOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const handleImageClick = (img) => setModalImage(img);
  const handleClose = () => setModalImage(null);

  useEffect(() => {
    handleGetPrintType_list({ setLoading, setClothOptions });
  }, []);

  useEffect(() => {
    if (quote?.length > 0) {
      if (clothOptions?.length > 0) {
        const result = clothOptions?.find(
          (item) => item.id === quote?.[0]?.print_type_id
        );
        setSelectedCloth(result);
      }
    }
  }, [quote, clothOptions]);

  return (
    <>
      <div className="cloth-list-wrapper">
        {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <Row className="g-2 g-sm-3">
            {clothOptions.map((item) => (
              <Col xs={6} sm={6} className="mb-2" key={item.id}>
                <Card
                  className={`cloth-card product-card h-100 ${
                    selectedCloth?.id === item.id ? "selected" : ""
                  } ${quote?.length > 0 ? "disabled" : ""}`}
                  onClick={() => setSelectedCloth(item)}
                >
                  <Card.Body className="p-2 text-center">
                    <div className="position-relative">
                      <Form.Check
                        type="radio"
                        id={item.id}
                        name="clothId"
                        value={item.id}
                        checked={selectedCloth?.id === item.id}
                        onChange={() => setSelectedCloth(item)}
                        className="cloth-radio"
                      />
                      <Image
                        src={getImageUrl(item?.imgpath)}
                        rounded
                        className="cloth-image-large"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImageClick(getImageUrl(item?.imgpath));
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                    <div className="cloth-label mt-2 fw-semibold">
                      {item?.print_type_name}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>

      <Modal show={!!modalImage} onHide={handleClose} centered>
        <Button
          variant="light"
          onClick={handleClose}
          className="modal-close-btn"
        >
          &times;
        </Button>
        <Modal.Body className="p-0 text-center modal-image-body">
          <Image src={modalImage} className="modal-image" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PrintType;
